const pct = value => `<span dir="ltr">${value}%</span>`

const tapsi = {
  company: "تپسی",
  logo: "/images/jetClubLogo/tapsi.png",
  activity: "حمل و نقل (درون شهری)",
  comment:
    "<p>کاربران جدید: یک کد 60 هزارتومانی ( 3 سفر 20 هزار تومانی برای سفر اول )</p><p>کاربران فعال: یک کد 40 هزار تومانی ( 2 سفر 20 هزار تومانی و یا 4 سفر 10 هزار تومانی )</p>"
}

const superMarketDigikala = {
  company: "سوپر مارکت فوری دیجی کالا",
  logo: "/images/jetClubLogo/super-market-digikala.png",
  activity: "سوپر مارکتی",
  comment:
    "<p>کاربران جدید: 100 هزار تومان تخفیف برای خریدهای بیشتر از یک میلیون تومان ویژه مشتریان جدید سوپر مارکت فوری دیجی کالا</p>"
}

const superMarketDigikalaPlan10 = {
  ...superMarketDigikala,
  comment: "<p>کاربران جدید: 100 هزار تومان تخفیف برای خریدهای بیشتر از یک میلیون تومان ویژه مشتریان جدید</p>"
}

const snapExpress = {
  company: "اسنپ اکسپرس",
  logo: "/images/jetClubLogo/snap-express.png",
  activity: "سوپر مارکتی",
  comment:
    "<p>20 هزار تومان برای حداقل خرید 150 هزار تومان ( این کد تخفیف در یک ماه 5 بار قابل استفاده می باشد)</p>"
}

const snapExpressPlan10 = {
  ...snapExpress,
  comment:
    "<p>20 هزار تومان برای حداقل خرید 150 هزار تومان ( این کد تخفیف در یک ماه 5 مرتبه قابل استفاده می باشد)</p>"
}

const okala = {
  company: "اُکالا",
  logo: "/images/jetClubLogo/okala.png",
  activity: "سوپر مارکتی",
  comment:
    "<p>کاربران جدید: 40 هزار تومان تخفیف روی سبد خرید 300 هزار تومان ( ویژه مشتریان جدید )</p>"
}

const faraKetab = {
  company: "فراکتاب",
  logo: "/images/jetClubLogo/fara-ketab.png",
  activity: "کتاب",
  comment:
    `<p>کتاب های صوتی الکترونیکی: ${pct(60)} تخفیف</p><p>کتاب های چاپی: ${pct(22)} تخفیف</p>`
}

const modiseh = {
  company: "مدیسه",
  logo: "/images/jetClubLogo/mediseh.png",
  activity: "پوشاک",
  comment:
    "<p>200 هزار تومان روی سبد خرید یک میلیون تومان (فقط روی محصولات پوشاک و لوازم آرایشی بهداشتی)</p>"
}

const jajiga = {
  company: "جاجیگا",
  logo: "/images/jetClubLogo/jajiga.png",
  activity: "اقامتگاه",
  comment:
    "<p>250 هزار تومان تخفیف روی رزرو 2 میلیون تومان (قابل استفاده یک‌ بار برای هر کاربر)</p>"
}

const snapTrip = {
  company: "اسنپ تریپ",
  logo: "/images/jetClubLogo/snap-trip.png",
  activity: "گردشگری",
  comment:
    "<p>رزرو پرواز های داخلی: 60 هزار تومان تخفیف</p><p>رزرو هتل های داخلی: 100 هزار تومان تخفیف</p><p>رزرو هتل های خارجی: 200 هزار تومان تخفیف</p>"
}

const shab = {
  company: "شب",
  logo: "/images/jetClubLogo/shab.png",
  activity: "اقامتگاه",
  comment: `<p>${pct(8)} تخفیف تا سقف 850 هزار تومان</p>`
}

const banimode = {
  company: "بانی مد",
  logo: "/images/jetClubLogo/banimode.png",
  activity: "پوشاک",
  comment: `<p>${pct(10)} تخفیف</p>`
}

const khanomi = {
  company: "خانومی",
  logo: "/images/jetClubLogo/khanomi.png",
  activity: "پوشاک",
  comment:
    "<p>کاربران جدید: 200 هزار تومان تخفیف روی سبد خرید 1 میلیون تومان ویژه مشتریان جدید</p><p>کاربران فعال: 100 هزار تومان تخفیف روی سبد خرید 800 هزار تومان ویژه همه مشتریان</p>"
}

const safirStore = {
  company: "فروشگاه اینترنتی (سفیر)",
  logo: "/images/jetClubLogo/safir-store.png",
  activity: "فروشگاه آنلاین",
  comment:
    "<p>کاربران جدید: 200 هزار تومان تخفیف روی سبد خرید 1 میلیون تومان ویژه مشتریان جدید</p><p>کاربران فعال: 150 هزار تومان تخفیف روی سبد خرید 1 میلیون تومان ویژه همه مشتریان</p>"
}

const roisa = {
  company: "رویسا",
  logo: "/images/jetClubLogo/roisa.png",
  activity: "پوشاک",
  comment: `<p>${pct(10)} تخفیف</p>`
}

const timarGashtKavir = {
  company: "تیمار گشت کویر",
  logo: "/images/jetClubLogo/timar-gasht-kavir.png",
  activity: "گردشگری و تفریحی",
  comment: `<p>${pct(12)} تخفیف</p>`
}

const tival = {
  company: "تیوال",
  logo: "/images/jetClubLogo/tival.png",
  activity: "سرگرمی",
  comment:
    `<p>باشگاه مشتریان تیوال: ${pct(20)} تا ${pct(50)} تخفیف در خرید خود از باشگاه مشتریان تیوال</p><p>تیوال پلاس: ${pct(40)} تخفیف بر روی اشتراک 3 ماهه، 6 ماه، و یکساله تیوال پلاس</p>`
}

const azki = {
  company: "ازکی",
  logo: "/images/jetClubLogo/azkibimeh.png",
  activity: "خدمات بیمه ای",
  comment:
    `<p>بیمه شخص ثالث خودرو: ${pct(7)} تخفیف تا سقف 165 هزار تومان</p><p>بیمه بدنه: ${pct(14)} تخفیف تا سقف 140 هزار تومان</p><p>بیمه شخص ثالث موتور سیکلت: ${pct(7)} تخفیف تا سقف 85 هزار تومان</p><p>بیمه آتش سوزی منازل مسکونی: ${pct(18)} تخفیف تا سقف 50 هزار تومان</p><p>بیمه مسافرتی: ${pct(20)} تخفیف تا سقف 45 هزار تومان</p><p>بیمه مسئولیت پزشکان و پیراپزشکان: ${pct(20)} تخفیف تا سقف 140 هزار تومان</p><p>بیمه درمان تکمیلی انفرادی: ${pct(20)} تخفیف تا سقف 240 هزار تومان</p>`
}

const bimeBazar = {
  company: "بیمه بازار",
  logo: "/images/jetClubLogo/bimebazar.png",
  activity: "خدمات بیمه ای",
  comment:
    `<p>بیمه شخص ثالث: ${pct(9)} تخفیف تا سقف 2 میلیون تومان</p><p>بیمه بدنه: ${pct(20)} تخفیف تا سقف 3 میلیون تومان</p><p>بیمه درمان تکمیلی انفرادی: ${pct(9)} تخفیف بدون سقف</p><p>بیمه درمان تکمیلی گروهی: ${pct(6)} تخفیف بدون سقف</p><p>بیمه آتش سوزی: ${pct(10)} تخفیف بدون سقف</p><p>بیمه عمر: ${pct(7)} تخفیف بدون سقف</p>`
}

const sibche = {
  company: "سیبچه",
  logo: "/images/jetClubLogo/sibche.png",
  activity: "نرم افزار موبایل",
  comment: `<p>${pct(33)} تخفیف بر روی اشتراک های 3 و 6 ماهه</p>`
}

const piodapp = {
  company: "پیوداپ",
  logo: "/images/jetClubLogo/piodapp.png",
  activity: "نرم افزار موبایل",
  comment: `<p>${pct(20)} تخفیف</p>`
}

const level1Base = [tapsi, superMarketDigikala, snapExpress, okala]

export const plan1 = [...level1Base]

export const plan2 = [...level1Base, faraKetab]

export const plan3 = [...level1Base, modiseh, faraKetab]

export const plan4 = [...level1Base, jajiga, modiseh, faraKetab]

export const plan5 = [...level1Base, snapTrip, jajiga, shab, modiseh, faraKetab]

export const plan6 = [...level1Base, snapTrip, jajiga, shab, banimode, modiseh, khanomi, faraKetab]

export const plan7 = [
  ...level1Base,
  snapTrip,
  jajiga,
  shab,
  banimode,
  modiseh,
  khanomi,
  safirStore,
  faraKetab,
  roisa
]

export const plan8 = [
  ...level1Base,
  snapTrip,
  jajiga,
  shab,
  banimode,
  modiseh,
  timarGashtKavir,
  khanomi,
  safirStore,
  tival,
  faraKetab,
  roisa
]

export const plan9 = [
  ...level1Base,
  snapTrip,
  jajiga,
  shab,
  banimode,
  modiseh,
  azki,
  timarGashtKavir,
  khanomi,
  safirStore,
  tival,
  faraKetab,
  roisa,
  sibche
]

export const plan10 = [
  tapsi,
  superMarketDigikalaPlan10,
  snapExpressPlan10,
  okala,
  snapTrip,
  jajiga,
  shab,
  banimode,
  modiseh,
  bimeBazar,
  azki,
  timarGashtKavir,
  khanomi,
  safirStore,
  tival,
  faraKetab,
  roisa,
  sibche,
  piodapp
]

export let defaultPlan = plan1
